import { createNode } from '@glueapp/graph-types';

export const FunctionNode = createNode({
    id: 'function',
    name: 'Function',
    description: 'Function',
    aiDescription: [
        'Represents a call to a user-defined function. Not directly addable from the library — created by referencing a function.',
        "Its input and output ports are dynamically generated via computeShape from the referenced function's port definitions (referencedFunctionId).",
        'To use: create a function definition first, then this node appears as a callable reference.',
        "Connect values to the generated input ports; outputs match the function's output port definitions.",
    ].join('\n'),
    category: 'Functions',
    color: '#8B5CF6',
    findableInLibrary: false,

    // This node has no ports initially - they will be dynamically generated
    // based on the function definition once created
    inPorts: {},
    outPorts: {},

    computeShape: ({ containingFunctionDefinition, referencedFunctionId, allFunctions }) => {
        const referencedFunction = allFunctions?.find(f => f.id === referencedFunctionId);

        const inPorts =
            referencedFunction?.inputPortDefinitions?.map(def => ({
                name: def.name,
                type: def.type,
                optional: def.optional || false,
            })) || [];

        const outPorts =
            referencedFunction?.outputPortDefinitions?.map(def => ({
                name: def.name,
                type: def.type,
                optional: def.optional || false,
            })) || [];

        return {
            inPorts,
            outPorts,
        };
    },

    execute: input => {
        // This node doesn't execute directly - it's replaced with a function instance
        // referencing the created function
        return { output: {} };
    },
});
